import actions, { defaultTheme, initialOptionalFields } from './actions';
import mutations from './mutations';
import getters from './getters';
import cloneDeep from 'lodash/cloneDeep';

export const initialState = {
  dark: cloneDeep(defaultTheme.dark),
  light: cloneDeep(defaultTheme.light),
  organizationId: '',
  uri: '',
  darkMode: true,
  logo: '',
  font: 'Roboto',
  updatedAt: '2020-06-12T20:12:45.505Z',
  updatedBy: 'Jane Doe',
  optionalFields: initialOptionalFields,
  overrideDefaultTheme: false
};

export default {
  namespaced: false,
  state: { ...initialState },
  mutations,
  actions,
  getters
};
